import { makeStyles, Theme } from "@material-ui/core"
import Tab from "@material-ui/core/Tab"
import Tabs from "@material-ui/core/Tabs"
import React, { useState, useContext } from "react"
import SwipeViews from "react-swipeable-views"
import Material from "Components/Material"
import { AppContext } from "../Home/context"
import { MplColumns, MplTableTitle } from "./constant"
import { ChannelTab } from "Types/app"


const useStyles = makeStyles((theme: Theme) => ({
    "@global": {
        "#root": {
            display: "flex",
        },
    },
    root: {
        backgroundColor: theme.palette.background.paper,
    },
    tabIndicator: {
        height: 0,
    },
    tabItem: {
        lineHeight: 1,
        marginTop: 4,
        borderRadius: theme.shape.borderRadius,
        fontSize: 14,
        minHeight: 0,
        backgroundColor: "#DDDDDD",
        marginRight: 10,
    },
    selectedItem: {
        backgroundColor: "#ff9800",
        color: "white",
        borderWidth: 0,
    },
}))

const Index = () => {
    const classes = useStyles()
    const [index, setIndex] = useState(0)
    const { user } = useContext(AppContext)
    const { role } = user || {}
    const { role_name } = role || {}
    const tabArray: ChannelTab[] = [
        {
            value: "wechat",
            text: "微信",
        },
        {
            value: "weibo",
            text: "微博",
        },
        {
            value: "species",
            text: "果壳自然",
        },
        {
            value: "health",
            text: "果壳病人",
        }
    ]

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setIndex(newValue)
    }
    const handleChangeIndex = (index: number) => {
        setIndex(index)
    }
    return (
        <div className={classes.root}>
            <Tabs
                value={index}
                onChange={handleChange}
                classes={{
                    indicator: classes.tabIndicator,
                }}
                centered
            >
                {
                    tabArray.map((tab: ChannelTab, index) => (
                        <Tab
                            label={tab.text}
                            key={tab.value}
                            value={index}
                            classes={{
                                root: classes.tabItem,
                                selected: classes.selectedItem,
                            }}
                        />
                    ))
                }
            </Tabs>
            <SwipeViews
                index={index}
                onChangeIndex={handleChangeIndex}
            >
                {
                    tabArray.map((tab: ChannelTab, index) => (
                        <Material
                            key={tab.value}
                            channelName={tab.value}
                            columns={MplColumns[tab.value]}
                            title={MplTableTitle}
                        />
                    ))
                }
            </SwipeViews>
        </div>
    )
}

export default Index
